import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const notificationOpenedV1Schema = eventEnvelopeSchema.extend({
  notificationId: z.string().min(1).max(256),
  channel: z.literal('in_app'),
  template: z.string().min(1).max(256),
  provider: z.string().min(1).max(256),
  userId: z.string().min(1).max(256).optional(),
});

export type NotificationOpenedV1 = z.infer<typeof notificationOpenedV1Schema>;

export const NOTIFICATION_OPENED_V1_DETAIL_TYPE =
  'notification.opened.v1' as const;
